export default __webpack_public_path__ + "static/media/heart.ac661340.svg";